export default class Event {
  constructor(id, startDate, endDate, title, description, image, imageUrl, fullPath, created) {
    this.id = id != null ? id : "";
    this.startDate = startDate != null ? startDate : "";
    this.endDate = endDate != null ? endDate : "";
    this.title = title != null ? title : "";
    this.description = description != null ? description : "";
    this.image = image != null ? image : "";
    this.imageUrl = imageUrl != null ? imageUrl : "";
    this.fullPath = fullPath != null ? fullPath : "";
    this.created = created != null ? created : "";
  }
}